// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sy-0";
export var checkoutRateBadgeLink = "_sy-1";